import classNames from 'classnames';
import * as React from 'react';
import { TNativeAccordionSelectable } from './NativeAccordion.types';
import './NativeAccordion.styles.scss';

const SPACE_KEY = ' ';
const ENTER_KEY = 'Enter';

export const NativeAccordionSelectable: TNativeAccordionSelectable = ({
  onClick,
  selected = false,
  title,
}) => {
  const handleKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (!onClick) {
      return;
    }

    if (event.key === ENTER_KEY || event.key === SPACE_KEY) {
      event.preventDefault();
      onClick();
    }
  };

  return (
    <div
      className={classNames('native-accordion__content__selectable', {
        'native-accordion__content__selectable--selected': selected,
      })}
      role="button"
      tabIndex={onClick ? 0 : -1}
      onClick={onClick}
      onKeyDown={handleKeyDown}
      aria-pressed={selected}
    >
      <p className="body2">{title}</p>
    </div>
  );
};
